import { DatapointVariant } from 'owa-analytics';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import { getFocusedFilterForTable, listViewStore, getSortByForTable, } from 'owa-mail-list-store';
function getSortColumnToLog(tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    var sortColumn = null;
    if (tableView) {
        var isSortBySupported = tableView.tableQuery.type == 0 /* Folder */ ||
            tableView.tableQuery.type == 2 /* Group */;
        sortColumn = isSortBySupported ? getSortByForTable(tableView).sortColumn : null;
    }
    return sortColumn;
}
export default {
    blockSendersFromTableDatapoint: {
        datapoint: {
            name: 'TnS_BlockSendersFromListView',
            customData: function (rowKeys, tableView, actionSource) { return [
                actionSource,
                rowKeys.length,
                tableView.tableQuery.type,
            ]; },
        },
    },
    blockSenderFromReadingPaneDatapoint: {
        datapoint: {
            name: 'TnS_BlockSenderFromReadingPane',
        },
    },
    setConversationsFlagStateDatapoint: { datapoint: { name: 'TnS_FlagConversation' } },
    setItemsFlagStateDatapoint: { datapoint: { name: 'TnS_FlagItems' } },
    archiveMailListRowsDatapoint: {
        datapoint: {
            name: 'TnS_ArchiveMailListRows',
            customData: function (rowKeys, tableView, actionSource) { return [
                actionSource,
                rowKeys.length,
                tableView.tableQuery.type,
                tableView.tableQuery.listViewType,
            ]; },
        },
    },
    deleteConversationDatapoint: {
        datapoint: {
            name: 'TnS_DeleteConversation',
            options: { isQos: true },
            customData: function (conversationActionContexts, originalTableViewId, disposalType, instrumentationContexts, actionSource) { return [
                actionSource,
                conversationActionContexts.length,
                disposalType,
                getSortColumnToLog(originalTableViewId),
            ]; },
        },
    },
    deleteItemsDatapoint: {
        datapoint: {
            name: 'TnS_DeleteItem',
            options: { isQos: true },
            customData: function (itemIds, disposalType, parentFolderId, actionSource, requestInitOptions) { return [actionSource, itemIds.length, disposalType]; },
        },
    },
    deleteItemsFromTableDatapoint: {
        datapoint: {
            name: 'TnS_DeleteItemsFromTable',
            customData: function (itemRowKeys, tableViewId, actionSource) { return [actionSource, itemRowKeys.length, getSortColumnToLog(tableViewId)]; },
        },
    },
    markItemsJunkNotJunkDatapoint: {
        datapoint: {
            name: 'TnS_JunkItem',
            customData: function (itemIds, isJunkValueToSet, actionSource) { return [actionSource, itemIds.length, isJunkValueToSet]; },
        },
    },
    markItemsAsPhishingDatapoint: {
        datapoint: {
            name: 'TnS_PhishItem',
            customData: function (itemIds, parentFolderId, actionSource) { return [
                actionSource,
                itemIds.length,
            ]; },
        },
    },
    moveConversationDatapoint: {
        datapoint: {
            name: 'TnS_MoveConversation',
            customData: function (rowKeys, destinationFolderId, originalTableView, actionSource) { return [
                actionSource,
                originalTableView.tableQuery.type,
                originalTableView.tableQuery.folderId // folderId is null in search
                    ? folderIdToName(originalTableView.tableQuery.folderId)
                    : null,
                folderIdToName(destinationFolderId),
                rowKeys.length,
            ]; },
            options: function (rowKeys, destinationFolderId, originalTableView, actionSource) {
                return {
                    variant: actionSource == 'NonUserAction'
                        ? DatapointVariant.None // Do not log the datapoint if it's not user triggered
                        : DatapointVariant.Both,
                };
            },
        },
    },
    moveItemsDatapoint: {
        datapoint: {
            name: 'TnS_MoveItem',
            customData: function (itemIds, destinationFolderId, originalTableView, actionSource) { return [
                actionSource,
                originalTableView.tableQuery.type,
                originalTableView.tableQuery.folderId // folderId is null in search
                    ? folderIdToName(originalTableView.tableQuery.folderId)
                    : null,
                folderIdToName(destinationFolderId),
                itemIds.length,
            ]; },
            options: function (itemIds, destinationFolderId, originalTableView, actionSource) {
                return {
                    variant: actionSource == 'NonUserAction'
                        ? DatapointVariant.None // Do not log the datapoint if it's not user triggered
                        : DatapointVariant.Both,
                };
            },
        },
    },
    restoreConversationDatapoint: { datapoint: { name: 'TnS_RestoreConversation' } },
    restoreItemsDatapoint: { datapoint: { name: 'TnS_RestoreItems' } },
    unsubscribeDatapoint: {
        datapoint: {
            name: 'TnS_Unsubscribe',
            customData: function (message, originalTableView, isTrustedUnsubscribe, actionSource) { return [actionSource, isTrustedUnsubscribe]; },
        },
    },
    emptyFolderDatapoint: {
        datapoint: {
            name: 'TnS_EmptyFolder',
            customData: function (actionSource, totalCount, emptyFolderName, currentFolderName, disposalType, treeType) { return [
                actionSource,
                totalCount,
                emptyFolderName,
                currentFolderName,
                disposalType,
                treeType,
            ]; },
        },
    },
    optOutDatapoint: { datapoint: { name: 'TnS_OptOut' } },
    pinConversationsDatapoint: {
        datapoint: {
            name: 'TnS_PinConversations',
            customData: function (conversationRowKeys, tableView, shouldMarkAsPinned, actionSource) { return [actionSource, shouldMarkAsPinned, conversationRowKeys.length]; },
        },
    },
    pinItemsDatapoint: {
        datapoint: {
            name: 'TnS_PinItems',
            customData: function (rowKeys, tableView, shouldMarkAsPinned, actionSource) { return [actionSource, shouldMarkAsPinned, rowKeys.length]; },
        },
    },
    moveConversationToFocusedOrOther: {
        datapoint: {
            name: 'TnS_MoveConversationToFocusedOrOther',
            customData: function (conversationRowKeys, tableViewId, actionSource) { return [
                actionSource,
                conversationRowKeys.length,
                getFocusedFilterForTable(listViewStore.tableViews.get(tableViewId)),
            ]; },
        },
    },
    alwaysMoveRowToFocusedOrOtherDatapoint: {
        datapoint: {
            name: 'TnS_AlwaysMoveRowToFocusedOrOther',
            customData: function (rowKeys, tableView, actionSource) { return [actionSource, getFocusedFilterForTable(tableView)]; },
        },
    },
    addCategories: {
        datapoint: {
            name: 'Triage_AddCategories',
            customData: function (rowKeys, tableView, categoriesToAdd, actionSource) { return [actionSource, rowKeys.length, tableView.tableQuery.listViewType]; },
        },
    },
    removeCategories: {
        datapoint: {
            name: 'Triage_RemoveCategories',
            customData: function (rowKeys, tableView, categoriesToRemove, actionSource) { return [actionSource, rowKeys.length, tableView.tableQuery.listViewType]; },
        },
    },
    clearCategories: {
        datapoint: {
            name: 'Triage_ClearCategories',
            customData: function (rowKeys, tableView, actionSource) { return [
                actionSource,
                rowKeys.length,
                tableView.tableQuery.listViewType,
            ]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map